/** Settings: misma tarjeta que habitación + checkbox de selección (paridad EvoHome). */

import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { PiletaDevice } from '../../services/piletaApi';
import PiletaDeviceCard from './PiletaDeviceCard';

interface PiletaDeviceCardSettingsProps {
  device: PiletaDevice;
  isSelected: boolean;
  editMode: boolean;
  isRoomEditing?: boolean;
  isEditingName?: boolean;
  dragHandleProps?: Record<string, unknown>;
  onSelect?: (id: number) => void;
  onClick?: (device: PiletaDevice) => void;
  onStartEditName?: () => void;
  onSaveEditName?: (newName: string) => void;
  onCancelEditName?: () => void;
  aiPolicyRevision?: number;
}

const PiletaDeviceCardSettings: React.FC<PiletaDeviceCardSettingsProps> = ({
  device,
  isSelected,
  editMode,
  isRoomEditing = false,
  isEditingName = false,
  dragHandleProps,
  onSelect,
  onClick,
  onStartEditName,
  onSaveEditName,
  onCancelEditName,
  aiPolicyRevision = 0,
}) => (
  <Box sx={{
    position: 'relative',
    border: isSelected ? '1px solid #2391FF' : 'none',
    borderRadius: 2,
    overflow: 'visible',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  }}>
    <PiletaDeviceCard
      device={device}
      onOpen={editMode || isRoomEditing || isEditingName ? undefined : onClick}
      interactionLocked={isRoomEditing || isEditingName}
      editMode={editMode}
      isRoomEditing={isRoomEditing}
      isEditingName={isEditingName}
      dragHandleProps={dragHandleProps}
      onStartEditName={onStartEditName}
      onSaveEditName={onSaveEditName}
      onCancelEditName={onCancelEditName}
      showBrandChip={editMode}
      aiPolicyRevision={aiPolicyRevision}
    />

    {editMode && onSelect && !isRoomEditing && (
      <Checkbox
        checked={isSelected}
        onChange={(e) => {
          e.stopPropagation();
          onSelect(device.id);
        }}
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: 'absolute',
          bottom: '-5px',
          right: '-5px',
          color: 'red',
          zIndex: 6,
          '& .MuiSvgIcon-root': { color: 'red' },
        }}
      />
    )}
  </Box>
);

export default PiletaDeviceCardSettings;
